<nz-row nzGutter="8">
  <nz-col nzSpan="24">
    <nz-row nzGutter="8">
      <nz-col nzSpan="4" nzXs="24" nzSm="5"><nz-form-label nzFor="filterDate">Date</nz-form-label></nz-col>
      <nz-col nzSpan="12" nzXs="24" nzSm="19">
        <nz-form-item>
          <nz-range-picker [(ngModel)]="filterDate" nzDropdownClassName="customCalendar" (ngModelChange)="onDateChange($event)"></nz-range-picker>
        </nz-form-item>
      </nz-col>
    </nz-row>
    <nz-row nzGutter="8">
      <nz-col nzSpan="4" nzXs="24" nzSm="5"><nz-form-label nzFor="filterDate">Document #</nz-form-label></nz-col>
      <nz-col nzSpan="12" nzXs="24" nzSm="19">
        <nz-form-item *ngIf="this.docType === 'QT'">
          <app-qt-select [(ngModel)]="this.docFrom" class="report-control" (ngModelChange)="onDocChange()"
            valueField="docCode" [outstandingOnly]="true">
          </app-qt-select>
          <span class="text-center">
            <span nz-icon nzType="swap-right" nzTheme="outline"></span>
          </span>
          <app-qt-select [(ngModel)]="this.docTo" class="report-control" (ngModelChange)="onDocChange()"
            valueField="docCode" [outstandingOnly]="true">
          </app-qt-select>
        </nz-form-item>
        <nz-form-item *ngIf="this.docType === 'SO'">
          <app-so-select [(ngModel)]="this.docFrom" class="report-control" (ngModelChange)="onDocChange()"
            valueField="docCode" [outstandingOnly]="true">
          </app-so-select>
          <span class="text-center">
            <span nz-icon nzType="swap-right" nzTheme="outline"></span>
          </span>
          <app-so-select [(ngModel)]="this.docTo" class="report-control" (ngModelChange)="onDocChange()"
            valueField="docCode" [outstandingOnly]="true">
          </app-so-select>
        </nz-form-item>
        <nz-form-item *ngIf="this.docType === 'DO'">
          <app-do-select [(ngModel)]="this.docFrom" class="report-control" (ngModelChange)="onDocChange()"
            valueField="docCode" [outstandingOnly]="true">
          </app-do-select>
          <span class="text-center">
            <span nz-icon nzType="swap-right" nzTheme="outline"></span>
          </span>
          <app-do-select [(ngModel)]="this.docTo" class="report-control" (ngModelChange)="onDocChange()"
            valueField="docCode" [outstandingOnly]="true">
          </app-do-select>
        </nz-form-item>
        <nz-form-item *ngIf="this.docType === 'CS'">
          <app-cs-select [(ngModel)]="this.docFrom" class="report-control" (ngModelChange)="onDocChange()"
            valueField="docCode" [outstandingOnly]="true">
          </app-cs-select>
          <span class="text-center">
            <span nz-icon nzType="swap-right" nzTheme="outline"></span>
          </span>
          <app-cs-select [(ngModel)]="this.docTo" class="report-control" (ngModelChange)="onDocChange()"
            valueField="docCode" [outstandingOnly]="true">
          </app-cs-select>
        </nz-form-item>
      </nz-col>

    </nz-row>
  </nz-col>
</nz-row>


<nz-table #t [nzData]="srv.outstandingDocs" [nzFrontPagination]="false" [nzShowPagination]="false" nzBordered="true"
  nzSize="small" [nzScroll]="{ x: '800px', y: '400px' }">
  <thead>
    <tr>
      <th *ngIf="!disabled" nzWidth="100px" [nzAlign]="'center'">
        Transfer
      </th>
      <ng-container *ngFor="let col of columns; let index = index; let last = last">
        <th [nzWidth]="$any(col)?.width" nz-resizable nzPreview (nzResizeEnd)="col.width = $event.width + 'px'"
          [nzAlign]="$any(col).align ?? 'left'">
          <nz-resize-handle *ngIf="!last" nzDirection="right">
            <i></i>
          </nz-resize-handle>
          {{ col.title }}
        </th>
      </ng-container>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of t.data">
      <td *ngIf="!disabled">
        <nz-switch [ngModel]="item.isTransfer" [nzControl]="true" (click)="toggleTransfer(item)">
        </nz-switch>
      </td>
      <td>
        {{ item.docDate | customDate}}
      </td>
      <td>
        {{ item.docCode }}
      </td>
      <td>
        {{ item.referenceNo }}
      </td>
      <td>
        {{ item.customerName }}
      </td>
      <td class="text-right">
        {{ item.netTotalAmountLocal | price }}
      </td>
    </tr>
  </tbody>
</nz-table>
